$('.logo-bar').addClass('grid');
$('.logo-bar').addClass('grid--uniform');
$('.logo-bar').addClass('tiga-bar');
$('.logo-bar__item').addClass('grid__item');
$('.logo-bar__item').addClass('small--one-whole');
$('.logo-bar__item').addClass('medium-up--one-half');
$('.logo-bar__item').addClass('height');
$('.logo-bar').removeClass('logo-bar');
$('.logo-bar__item').removeClass('logo-bar__item');

$('.logo-bar-custom').addClass('grid');
$('.logo-bar-custom').addClass('grid--uniform');
$('.logo-bar-custom').addClass('grid-tiga');
$('.logo-bar__item-custom').addClass('grid__item');
$('.logo-bar__item-custom').addClass('small--one-half');
$('.logo-bar__item-custom').addClass('medium-up--one-third');
$('.logo-bar__item-custom').addClass('custom-grid');
$('.logo-bar-custom').removeClass('logo-bar-custom');
$('.logo-bar__item-custom').removeClass('logo-bar__item-custom');


function hover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0424/3079/1845/files/logo_h_60x.progressive.png?v=1594615328');
}

function unhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0424/3079/1845/files/woodka-logo-1522219832_60x.progressive.jpg?v=1593769231');
}

$('.vertical-slick').slick({
  dots: false,
  vertical: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  verticalSwiping: true
});

$('.best-combination').owlCarousel({
  loop: true,
  margin: 10,
  nav: true,
  navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
  autoplay: true,
  dots: false,
  responsive: {
    0: {
      items:2
    },
    600: {
      items:2
    },
    1000: {
      items:4
    }
  }
});

$('.collection-carousel').owlCarousel({
  loop:true,
  margin:10,
  nav: true,
  navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
  dots: false,
  responsive: {
    0: {
      items:2
    },
    600: {
      items:2
    },
    1000: {
      items:3
    }
  }
});

$('.spc-collection').owlCarousel({
  loop:true,
  margin:10,
  nav: true,
  navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
  dots: false,
  responsive: {
    0: {
      items:2
    },
    600: {
      items:2
    },
    1000: {
      items:4
    }
  }
});

$('.spc-slideshow').owlCarousel({
  loop:false,
  margin:0,
  nav: true,
  navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
  dots: false,
  items: 1
});

$('.carousel-with-image').owlCarousel({
  loop:true,
  margin:10,
  nav: true,
  navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
  responsive: {
    0: {
      items:2
    },
    600: {
      items:2
    },
    1000: {
      items:3
    }
  }
});


$('.carousel-with-image-right').owlCarousel({
  loop:true,
  nav: true,
  navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
  responsive: {
    0: {
      items:2
    },
    600: {
      items:2
    },
    1000: {
      items:3
    }
  }
});

$('.product-bundling').owlCarousel({
  loop: true,
  margin: 10,
  nav: false,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 1
    }
  }
});

$('.article-product').owlCarousel({
  loop: true,
  margin: 10,
  nav: true,
  navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
  responsive: {
    0: {
      items: 2
    },
    749: {
      items: 2
    },
    750: {
      items: 3
    }
  }
});

$(document).ready(function(){
  var produk1 = $('#produknya-0').val();
  var produk2 = $('#produknya-1').val();
  var stok1	  = $('#stok-produk-0').val();
  var stok2   = $('#stok-produk-1').val();
  
  var array_bundling = [produk1, produk2];
  
  if (stok1 > 0 && stok2 > 0){
    $('#bundling-package').click(function(){
      var cart = jQuery.post('/cart/add.js', {
        quantity: 1,
        id: array_bundling,
        properties: {
          'Bundling name': 'Product Recommendations'
        }
      });
      setTimeout(function(){
        window.location = '/cart';
      }, 2000);
    });
  }else if(stok1 > stok2){
    $('#button-bundling').attr('disabled', 'disabled');
    $('#button-bundling').html('OUT OF STOCK');
  }else if (stok1 < stok2){
    $('#button-bundling').attr('disabled', 'disabled');
    $('#button-bundling').html('OUT OF STOCK');
  }
  
});
$('.close-bogo').click(function(){
  $('.bogo').removeClass('show-modal');
});
$('body').keyup(function(event){
	if (event.keyCode == 27){
		$('body').removeClass('show-modal');
    }
});

var length_bogo = $('.produk-bogo').length;

for(var i = 1; i <= length_bogo; i++){
	$('.add-'+i+' #add_product').click(function(){
		var produk_id = $(this).val();
      	$('.bogo-loader#'+produk_id).removeClass('hide')
      	console.log(produk_id)
        var cart = jQuery.post('/cart/add.js', {
          quantity: 1,
          id: produk_id,
          properties: { 'Special Offers': 'Free item' }
        });
        setTimeout(function(){
          window.location = '/cart';
        }, 2000);
	});
}
$( window ).load(function() {
  var bogo_on = $('.ada-bogo').length;
  console.log(bogo_on);
  if(bogo_on > 0){
	  $('.bogo').addClass('hide');
  }
});

/*
 * CharacterCounter
 * @param textareaEl = textarea html element
 * @param remainingEl = element that includes the remaining value, updates with each event fire (keyUp)
 */
class CharacterCounter {
  constructor(textareaEl, remainingEl) {
    this.element = textareaEl;
    this.remainingEl = remainingEl;
    this.max = this.element.getAttribute("maxlength");
    this.remainingChars = this.max;
    this.currCounter = this.element.value.length;
    this.setEvents();
  }

  /* calculates the remaining characters
	 * @param event = event triggered from event listener
	 */
  calc(event) {
    this.remainingChars = this.element.value.length;
    this.updateRemainingEl();
  }

  /* sets the events that will be attacked on the element
	 */
  setEvents() {
    this.element.addEventListener("keyup", (event) => this.calc(event));
  }

  /* updates the remainingEl markup with the current remaining char value
	 */
  updateRemainingEl() {
    this.remainingEl.textContent = this.max - this.remainingChars;
  }
}

var textarea = document.getElementsByName("note")[0];
var remaining = document.querySelector("label span");
characterCounter = new CharacterCounter(textarea, remaining);
